export const BG_IMAGE =
  "https://customer-assets.emergentagent.com/job_37d91874-055e-4733-b3dd-bdd99f83cc88/artifacts/1sq98tty_freepik__create-an-background-image-without-the-login-based__59111.jpeg";

export const CARD = {
  background: "rgba(255, 255, 255, 0.18)",
  border: "1px solid rgba(255, 255, 255, 0.35)",
  backdropFilter: "blur(3px)",
  WebkitBackdropFilter: "blur(3px)",
  borderRadius: "0.875rem",
  boxShadow: "0 4px 24px rgba(26,77,46,0.06)",
};

export const ITEM = {
  background: "rgba(255, 255, 255, 0.82)",
  border: "1px solid rgba(255, 255, 255, 0.50)",
  borderRadius: "0.625rem",
};
